'use strict';

const _=require('pulsar-utils/dist-es6/_');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const LiveGroupBasedDataService=require('../../../dist-es6/client/services/liveGroupBasedDataService');

const DefaultQueryIntervalLookbackDuration=timespan.fromHours(12);let

FlightMonitorDataService=class FlightMonitorDataService extends LiveGroupBasedDataService{
constructor($timeout,dateService,statisticalDisplayDataService,groupTreeService,displaySettingsService){
super($timeout,dateService,statisticalDisplayDataService,groupTreeService,displaySettingsService);
}

async _fetchLatestData(...args){
const[options={}]=args;
const currentStatusSource='effectiveStatus';
const currentTime=this._dateService.now();
const groupId=this._displaySettingsService.stickySettings.get('selectedGroupId');

const queryInterval=options.visibleRange||TimeInterval.from(pulsarDate(currentTime).minus(DefaultQueryIntervalLookbackDuration)).spanning(timespan.fromDays(options.numFutureDays));

const fullOptions=_.defaults({currentTime,groupId,currentStatusSource,queryInterval},options);
const results=await this._statisticalDisplayDataService.fetchFlightMonitorData(fullOptions);

return new Promise(resolve=>{
this._$timeout(()=>{
this.currentTime=currentTime;
this.queryInterval=queryInterval;

resolve(results);
});
});
}


get shouldReloadForLatestGroupData(){
if(!_.exists(this.groupTree)){
return!1;
}

const currentlySelectedGroupId=this._displaySettingsService.stickySettings.get('selectedGroupId');
return!this._currentlyLoadedGroupIds.has(currentlySelectedGroupId);
}};


module.exports=FlightMonitorDataService;
//# sourceMappingURL=flightMonitorDataService.js.map
